//@ts-check
import axios from "axios";
import moment from "moment";

class Log {
    constructor() {
        this.last_ran = moment(0);
        this.count = 0;
    }

    /**
     *
     * @param {string | Event} message
     * @param {string} url
     * @param {number} line
     */
    sendMessage(message, url, line) {
        if (
            typeof message === "string" &&
            moment().diff(this.last_ran, "seconds") > 3 &&
            this.count < 10
        ) {
            var string = message.toLowerCase();
            var substring = "script error";
            if (string.indexOf(substring) > -1) {
                // Script Error: See Browser Console for Detail
                return;
            }
            this.last_ran = moment();
            this.count += 1;
            axios.post("/web-api/client-logger", {
                message,
                url,
                line
            });
        }
    }
}

export default new Log();
